import type { RouteRecord } from 'vite-react-ssg'
import { RootLayout } from './RootLayout'
import { LandingPage } from './pages/landing/LandingPage'
import { SignInPage } from './pages/auth/SignInPage'
import { CallbackPage } from './pages/auth/CallbackPage'
import { AccountTypePage } from './pages/auth/AccountTypePage'
import { SignUpPatientPage } from './pages/auth/SignUpPatientPage'
import { SignUpDoctorPage } from './pages/auth/SignUpDoctorPage'
import { SignUpCaregiverPage } from './pages/auth/SignUpCaregiverPage'
import { VerifyOtpPage } from './pages/auth/VerifyOtpPage'
import { ForgotPasswordPage } from './pages/auth/ForgotPasswordPage'
import { ResetPasswordPage } from './pages/auth/ResetPasswordPage'
import { CartPage } from './pages/cart/CartPage'
import { CheckoutPage } from './pages/checkout/CheckoutPage'
import { DashboardPage } from './pages/account/DashboardPage'
import { OrderHistoryPage } from './pages/account/OrderHistoryPage'
import { ProfilePage } from './pages/account/ProfilePage'
import { PrivateRoute } from './auth/PrivateRoute'
import { PrivacyPage } from './pages/legal/PrivacyPage'
import { TermsPage } from './pages/legal/TermsPage'

// Route table consumed by vite-react-ssg. The root layout holds the global
// providers; children are the same pages/paths as before. Which of these get
// prerendered to static HTML is controlled by `ssgOptions.includedRoutes` in
// vite.config.ts (marketing pages only) — the rest run as a client-side SPA.
export const routes: RouteRecord[] = [
  {
    path: '/',
    element: <RootLayout />,
    children: [
      // Public / marketing routes
      { index: true, element: <LandingPage /> },
      { path: 'sign-in', element: <SignInPage /> },
      { path: 'account-type', element: <AccountTypePage /> },
      { path: 'sign-up-patient', element: <SignUpPatientPage /> },
      { path: 'sign-up-doctor', element: <SignUpDoctorPage /> },
      { path: 'sign-up-caregiver', element: <SignUpCaregiverPage /> },

      // Legal pages (prerendered + indexed)
      { path: 'privacy', element: <PrivacyPage /> },
      { path: 'terms', element: <TermsPage /> },

      // Client-only auth flow (not prerendered, not indexed)
      { path: 'callback', element: <CallbackPage /> },
      { path: 'verify-otp', element: <VerifyOtpPage /> },
      // Password recovery. `/reset-password` is the target of the emailed link
      // built in admin-backend mailer.js#sendForgotPassword, and
      // `/forgot-password` is what the Sign In page links to — both routes were
      // missing, so every recovery attempt hit react-router's 404 error page.
      // Client-only: the reset URL carries a secret token, so never prerender.
      { path: 'forgot-password', element: <ForgotPasswordPage /> },
      { path: 'reset-password', element: <ResetPasswordPage /> },

      // Protected app routes (not prerendered, not indexed)
      { path: 'cart', element: <PrivateRoute><CartPage /></PrivateRoute> },
      { path: 'checkout', element: <PrivateRoute><CheckoutPage /></PrivateRoute> },
      { path: 'account', element: <PrivateRoute><DashboardPage /></PrivateRoute> },
      { path: 'account/orders', element: <PrivateRoute><OrderHistoryPage /></PrivateRoute> },
      { path: 'account/profile', element: <PrivateRoute><ProfilePage /></PrivateRoute> },
    ],
  },
]
